import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
import { PRICE_EUR } from './Shared';
export function UrgencyBanner() {
  const [timeLeft, setTimeLeft] = useState({
    h: 1,
    m: 0,
    s: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 w-full bg-brand-purpleDark text-brand-surface border-b border-brand-gold/40" data-id="element-231" data-mp="3b5woagx05wta">
      <div className="max-w-7xl mx-auto px-3 py-2 md:px-6 md:py-2.5" data-id="element-232" data-mp="1gtydiaj1osva">
        <div className="md:hidden overflow-hidden relative" data-id="element-233" data-mp="1gwcaioxacf5h">
          <motion.div className="flex items-center gap-6 whitespace-nowrap text-[13px] font-semibold w-max" animate={{
          x: ['0%', '-50%']
        }} transition={{
          duration: 20,
          ease: 'linear',
          repeat: Infinity
        }} data-id="element-234" data-mp="27frl6nzq9fiq">
            {[0, 1].map(dup => <div key={dup} className="flex items-center gap-6 shrink-0" data-id="element-235" data-mp="1sqleyg2h2p1c">
                <div className="flex items-center gap-1.5 shrink-0 text-brand-goldLight" data-id="element-236" data-mp="2qdkj1bvhuz99">
                  <Clock className="w-3.5 h-3.5 shrink-0" data-id="element-237" data-mp="2lehlsdlr9xbu" />
                  <span data-id="element-238" data-mp="2lf0ssz9vb1b3">Il prezzo di lancio si chiude tra</span>
                  <span className="font-mono font-bold tabular-nums border border-brand-gold/40 rounded-sm px-1.5 py-0.5 ml-0.5 text-white" data-id="element-239" data-mp="2gev67xigg4zv">
                    {fmt(timeLeft.h)}:{fmt(timeLeft.m)}:{fmt(timeLeft.s)}
                  </span>
                </div>
                <span className="w-1 h-1 rotate-45 bg-brand-goldLight/60 shrink-0" data-id="element-240" data-mp="14y500ee17d69" />
                <div className="flex items-center gap-1.5 shrink-0" data-id="element-241" data-mp="10xcofehosw6t">
                  <span className="w-1.5 h-1.5 rounded-full bg-brand-burgundy animate-pulse" data-id="element-242" data-mp="12gutzv19mbe5" />
                  <span data-id="element-243" data-mp="17duy40ek142m">
                    Prezzo di lancio{' '}
                    <strong className="text-brand-goldLight" data-id="element-244" data-mp="shvt4ymqrk1p">{PRICE_EUR}</strong>
                  </span>
                </div>
                <span className="w-1 h-1 rotate-45 bg-brand-goldLight/60 shrink-0" data-id="element-245" data-mp="xfxb1g8fldbl" />
                <a href="#pricing" className="inline-flex items-center gap-1 border border-brand-goldLight/70 text-brand-goldLight font-semibold uppercase tracking-wider px-2.5 py-0.5 rounded-sm text-[12px] shrink-0" data-id="element-246" data-mp="jos8a59ro4x1">
                  Vedi il pack
                </a>
              </div>)}
          </motion.div>
        </div>

        <div className="hidden md:flex items-center justify-center gap-6 text-xs font-semibold" data-id="element-247" data-mp="era4sueiqhwf">
          <div className="flex items-center gap-2 whitespace-nowrap text-brand-goldLight uppercase tracking-wider" data-id="element-248" data-mp="rinokspgle7">
            <Clock className="w-4 h-4 shrink-0" data-id="element-249" data-mp="4rjdf1l98j0k" />
            <span data-id="element-250" data-mp="3i8v6dk2ns5c0">Il prezzo di lancio si chiude tra</span>
            <span className="font-mono font-bold tabular-nums border border-brand-gold/40 rounded-sm px-2 py-0.5 text-white normal-case" data-id="element-251" data-mp="3i9eqn7fs75t7">
              {fmt(timeLeft.h)}:{fmt(timeLeft.m)}:{fmt(timeLeft.s)}
            </span>
          </div>
          <div className="w-px h-4 bg-brand-goldLight/30 shrink-0" data-id="element-252" data-mp="3mazz8gla8xxl" />
          <div className="flex items-center gap-2 whitespace-nowrap" data-id="element-253" data-mp="3mcuna3rup65w">
            <span className="w-1.5 h-1.5 rounded-full bg-brand-burgundy animate-pulse" data-id="element-254" data-mp="51bm5i3wb4ci" />
            <span className="text-brand-surface/85" data-id="element-255" data-mp="2gt7nc7rzeo">
              Prezzo di lancio{' '}
              <strong className="text-brand-goldLight" data-id="element-256" data-mp="dv6mmcu2o6lt">{PRICE_EUR}</strong>
            </span>
          </div>
          <a href="#pricing" className="inline-flex items-center gap-1 border border-brand-goldLight/70 text-brand-goldLight font-semibold uppercase tracking-wider px-3 py-1 rounded-sm text-[12px] hover:bg-brand-goldLight hover:text-brand-purpleDark transition-colors shrink-0" data-id="element-257" data-mp="9uec7g9grvny">
            Vedi il pack
          </a>
        </div>
      </div>
    </div>;
}